import React from 'react';
import {
  Button,
  Card,
  CardBody,
  Modal,
  ModalBody,
} from 'reactstrap';
import { RiAddLine, RiUpload2Line } from 'react-icons/ri';
import { FSBTable } from 'components/common/FSBTable';
import Heading from 'components/Heading';
import UploadCsvModal from './components/UploadCsvModal';

const GetLead = ({
  paginatedLeads,
  totalCount,
  totalPages,
  columns,
  currentPageNo,
  pageSize,
  isLeadsLoading,
  deleteConfirmId,
  isUploadCsvModalOpen,
  onOpenCreateLead,
  onOpenUploadCsv,
  onToggleUploadCsv,
  onUploadComplete,
  onPageChange,
  onLeadRowClick,
  onDeleteCancel,
  onDeleteConfirm,
}) => (
  <>
    <div className="mb-3 top-head crm-lead-page__list-header">
      <Heading title="Leads" />
      <div className="crm-lead-page__header-actions">
        <Button
          type="button"
          color="success"
          className="border border-1 border-success text-white fw-medium"
          style={{ borderRadius: 12 }}
          onClick={onOpenUploadCsv}
        >
          <RiUpload2Line className="me-1" size={16} />
          Upload CSV
        </Button>
        <Button
          type="button"
          color="primary"
          style={{ borderRadius: 12 }}
          onClick={onOpenCreateLead}
        >
          <RiAddLine className="me-1" size={18} />
          Manual Entry
        </Button>
      </div>
    </div>

    <Card className="border-0 card-box page-card-box">
      <CardBody>
        <FSBTable
          data={paginatedLeads}
          totalCount={totalCount}
          totalPages={totalPages}
          columns={columns}
          currentPageNo={currentPageNo}
          pageSize={pageSize}
          keyField="id"
          showSearch={false}
          showFilters={false}
          showDelete={false}
          showPagination={totalCount > 0}
          loading={isLeadsLoading}
          remote
          tableClass="text-nowrap crm-lead-table crm-lead-table--clickable"
          striped={false}
          hover={false}
          bordered={false}
          wrapperClass="crm-lead-table-wrap"
          tableWraperClass="min-h-table"
          handlePageChange={onPageChange}
          searchPlaceholder="Search Leads"
          onRowClick={onLeadRowClick}
        />
      </CardBody>
    </Card>

    <Modal isOpen={!!deleteConfirmId} toggle={onDeleteCancel} centered>
      <ModalBody className="text-center py-4">
        <p className="mb-4 text-dark fs-5">Do you really want to remove this record?</p>
        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button outline color="secondary" className="px-4 rounded-pill" onClick={onDeleteCancel}>
            Close
          </Button>
          <Button color="danger" className="px-4 rounded-pill" onClick={onDeleteConfirm}>
            Delete
          </Button>
        </div>
      </ModalBody>
    </Modal>

    <UploadCsvModal
      isOpen={isUploadCsvModalOpen}
      toggle={onToggleUploadCsv}
      onUploadComplete={onUploadComplete}
    />
  </>
);

export default GetLead;
